import { /*type ChangeEvent,*/ useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

const ChangePassword: React.FC<{
  open: boolean;
  onCancel?: () => void;
  onConfirm: (current: string, next: string) => void;
}> = ({ open, onCancel = () => {}, onConfirm = () => {} }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState("");
  const passwordInputRef1 = useRef<HTMLInputElement>(null);
  const passwordInputRef2 = useRef<HTMLInputElement>(null);
  const passwordInputRef3 = useRef<HTMLInputElement>(null);

  const passwordPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~]).{8,}$/;

  const handleChangePassword = () => {
    if (
      passwordInputRef2.current?.value !== passwordInputRef3.current?.value ||
      passwordInputRef1.current?.value === "" ||
      passwordInputRef2.current?.value === "" ||
      passwordInputRef3.current?.value === ""
    ) {
      setErrors(t("Passwords do not match"));
      return;
    }

    if (!passwordPattern.test(passwordInputRef2.current?.value || "")) {
      setErrors(t("Password must be at least 8 characters long and contain letters, numbers, and special characters"));
      return;
    }

    setErrors("");
    onConfirm(passwordInputRef1.current?.value || "", passwordInputRef2.current?.value || "");
  };

  return (
    <Dialog maxWidth="xs" open={open}>
      <DialogTitle>{t("Change Password")}</DialogTitle>
      <DialogContent>
        <TextField inputRef={passwordInputRef1} fullWidth type="password" label={t("Current Password")} variant="outlined" size="medium" />
        <TextField inputRef={passwordInputRef2} fullWidth type="password" label={t("New Password")} variant="outlined" size="medium" />
        <TextField inputRef={passwordInputRef3} fullWidth type="password" label={t("Enter New Password Again")} variant="outlined" size="medium" />
        {errors && (
          <Typography variant="body1" color="error" mt="0.5rem">
            {errors}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t("Cancel")}</Button>
        <Button onClick={handleChangePassword} variant="contained" autoFocus>
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePassword;
